<template>
  <v-row>
    <v-col cols="8">
      <v-text-field
        v-model="search"
        placeholder="Search Here..."
        v-on:keyup.enter="executeSearch()"
      >
      </v-text-field>
    </v-col>
    <v-col cols="4">
      <v-btn dense :color="'primary'" @click="executeSearch()">
        Search
      </v-btn>
      <v-btn class="ml-2" dense :color="'white'" @click="resetSearch()">
        Reset
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextReplacementSearch",
  data() {
    return {
      search: "",
    };
  },
  methods: {
    executeSearch () {
      this.$parent.executeSearch(this.search);
    },
    resetSearch () {
      this.search = '';
      this.$parent.executeSearch(null);
    }
  }
};
</script>